<zah-admins [initialPageRequest]="initialPageRequest"
            [adminsPage]="adminsPage$ | async"
            (adminClicked)="navigateToAdmin($event)"
            (deleteClicked)="deleteAdmin($event)"
            (addClicked)="navigateToAddAdmin()"
            (pageChange)="onPageChange($event)">
</zah-admins>
